import e, { useContext as u } from "react";
import { PrimaryNavContext as i } from "./PrimaryNavContext";
import { ChevronLeft as m } from "@hagerty/icons";

var b = function b(_ref) {
  var t = _ref.parentRef;

  var _u = u(i),
      a = _u.isSubmenuOpen,
      r = _u.setIsSubmenuOpen,
      o = _u.setActiveFlyout,
      n = _u.setIsAnimating;

  return e.createElement("div", {
    className: "hg-primarynav__item hg-primarynav__menuback"
  }, e.createElement("button", {
    className: "hg-primarynav__menuback-button",
    "aria-label": "Main menu",
    type: "button",
    onClick: function onClick() {
      a && (r(!1), o(t.current), n(!0), setTimeout(function () {
        n(!1);
      }, 240));
    }
  }, e.createElement("span", {
    className: "hg-primarynav__chevron-icon"
  }, e.createElement(m, null))));
};

export { b as MenuBackButton };